import React from 'react';
import {AutocompleteChangeReason} from "@mui/material";
import {AutocompleteOption} from "../../../SortFilter/interfaces";
import { FilterAutocomplete } from "../FilterAutocomplete/FilterAutocomplete";
import {useGetOptions, VariableInputOptionType} from "../../../../hooks/report/useGetOptions";

type BoundAutocompleteProps<T> =  {
  options: VariableInputOptionType;
  includeAllOption?: boolean;
  name: string;
  value?: string | number | null;
  label: string;
  onChange: (newQuery: T) => void;
}

const BoundAutocomplete = <T,>({
  options,
  includeAllOption = true,
  name,
  value = '',
  label,
  onChange
}: BoundAutocompleteProps<T>) => {
  const selectOptions = useGetOptions({ optionFormat: 'AUTOCOMPLETE', options, includeAllOption });

  const handleChange = (_event: React.SyntheticEvent<Element, Event>, newValue: AutocompleteOption, reason: AutocompleteChangeReason) => {
    if (reason !== 'createOption') {
      onChange({
        [name]: newValue?.id ?? ''
      } as unknown as T);
    }
  };

  return (
    <FilterAutocomplete
      label={label}
      value={value}
      options={selectOptions}
      onChange={handleChange}
    />
  )
};

export { BoundAutocomplete };